module.exports = __webpack_public_path__ + "static/media/reward-navigation-white.3f6637cd.svg";